import _ from 'lodash';
import { CoverageStatusLabels, InsuranceState } from '../types';
import {
  SET_INSURANCE_QUOTE,
  SET_VENDOR_OPPORTUNITY,
  SET_CREDIT_APPLICATION,
  SET_SUBMISSIONS,
  SET_IS_INSURANCE_EXPRESS_INTEGRATED,
  SET_PROPOSALS,
  SET_FINANCE_PROGRAMS,
  SET_SELECTED_SUBMISSION,
  SET_SELECTED_FINANCE_PROGRAM,
  SET_STEPPER_CONFIG,
  SET_ACCORDION_CONFIG,
  UPDATE_STEPPER_CONFIG,
  UPDATE_ACCORDION_CONFIG,
  SET_INSURANCE_BROKER,
  SET_INSURANCE_VERIFICATION_TASK,
  SET_INSURANCE_CERTIFICATE,
  SET_COVERAGE_STATUS_CONFIG,
  CLEAR_STATE,
} from './actionTypes';
import { accordionConfig, coverageStatusConfig, stepperConfig } from '../constants';

const initialState: InsuranceState = {
  insuranceQuote: null,
  vendorOpportunity: null,
  creditApplication: null,
  submissions: [],
  isInsuranceExpressIntegrated: null,
  proposals: [],
  financePrograms: [],

  selectedSubmission: null,
  selectedFinanceProgram: null,

  insuranceBroker: null,
  insuranceVerificationTask: null,
  insuranceCertificate: null,

  stepperConfig,
  accordionConfig,
  coverageStatusConfig: coverageStatusConfig[CoverageStatusLabels.Unknown],
};

export const insuranceReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case SET_INSURANCE_QUOTE:
      return { ...state, insuranceQuote: payload };
    case SET_VENDOR_OPPORTUNITY:
      return { ...state, vendorOpportunity: payload };
    case SET_CREDIT_APPLICATION:
      return { ...state, creditApplication: payload };
    case SET_SUBMISSIONS:
      return { ...state, submissions: payload };
    case SET_IS_INSURANCE_EXPRESS_INTEGRATED:
      return { ...state, isInsuranceExpressIntegrated: payload };
    case SET_PROPOSALS:
      return { ...state, proposals: payload };
    case SET_FINANCE_PROGRAMS:
      return { ...state, financePrograms: payload };
    case SET_SELECTED_SUBMISSION:
      return { ...state, selectedSubmission: payload };
    case SET_SELECTED_FINANCE_PROGRAM:
      return { ...state, selectedFinanceProgram: payload };
    /*     case SET_STEPPER_CONFIG:
      return { ...state, stepperConfig: payload };
    case SET_ACCORDION_CONFIG:
      return { ...state, accordionConfig: payload }; */
    case UPDATE_STEPPER_CONFIG:
      return {
        ...state,
        stepperConfig: state.stepperConfig.map((sc, idx) => (idx === payload.idx ? { ...sc, ...payload.config } : sc)),
      };
    case UPDATE_ACCORDION_CONFIG:
      return {
        ...state,
        accordionConfig: state.accordionConfig.map((ac, idx) =>
          idx === payload.idx ? { ...ac, ...payload.config } : ac
        ),
      };
    case SET_INSURANCE_BROKER:
      return { ...state, insuranceBroker: payload };
    case SET_INSURANCE_VERIFICATION_TASK:
      return { ...state, insuranceVerificationTask: payload };
    case SET_INSURANCE_CERTIFICATE:
      return { ...state, insuranceCertificate: payload };
    case SET_COVERAGE_STATUS_CONFIG:
      return { ...state, coverageStatusConfig: payload };

    case CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
};
